module.exports='<!-- @author Sergey Kuzhavskiy <Praffesor>--><gccs-note-list client-id="clientShowNotesCtrl.clientId" editable="true"></gccs-note-list>';